import { chakra } from '@chakra-ui/react';
import { FontAwesomeIcon as fai } from '@fortawesome/react-fontawesome';

const FontAwesomeIcon = chakra(fai);

export default FontAwesomeIcon;
